import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import styled from 'styled-components';

import { CareerIcon } from 'atoms';
import { Colors } from 'context';
import { useProfessions } from 'core';
import { GrowthProfessions } from 'components/pages/Growth/parts/GrowthProfessions';
import { skillMapHref } from 'router/careerLinks';
import { accent } from 'services/careerAccents';
import { careerLayout, careerType } from 'services/careerType';

import { GrowthSectionLayout } from './GrowthSectionLayout';

/**
 * `/career/professions` — витрина профессий И выбор карьерной цели.
 *
 * 🔴 Список ОДИН: две выборки одной таблицы `GrowthTrack` отличались ровно
 * кнопкой, и владелец честно не понимал, чем они отличаются (ТЗ 0069).
 *
 * Доработка 15.09: владелец назвал выбор цели через «Zawody» странным — было
 * не видно, какая цель уже выбрана, пока не пролистаешь до карточки. Теперь
 * текущая цель стоит строкой над каталогом, с переходом на её карту.
 */
export const GrowthProfessionList = memo(() => {
  const { t } = useTranslation();
  const { professions } = useProfessions();
  const goal = professions.find((row) => row.isChosen);
  const tone = accent('plan');

  return (
    <GrowthSectionLayout
      title={t('growth.professions.title')}
      lead={t('growth.professions.pageLead')}>
      {goal ? (
        <GoalBar $bg={tone.bg} $fg={tone.fg}>
          <CareerIcon name="goal" size={22} />
          <span>{t('growth.professions.currentGoal', { title: goal.title })}</span>
          <GoalLink to={skillMapHref({ track: goal.code })}>
            {t('growth.professions.openMap')}
          </GoalLink>
        </GoalBar>
      ) : null}
      <GrowthProfessions />
    </GrowthSectionLayout>
  );
});

const GoalBar = styled.p<{ $bg: string; $fg: string }>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  margin: 0;
  padding: 12px 16px;
  border-radius: ${careerLayout.cardRadius}px;
  background: ${({ $bg }) => $bg};
  color: ${({ $fg }) => $fg};
  ${careerType.bodyStrong()};
`;

const GoalLink = styled(Link)`
  margin-left: auto;
  color: ${Colors.black};
  text-decoration: underline;

  &:hover {
    color: ${Colors.black};
  }
`;
